import { CatListItem } from '@blocks-react/components/ListItem';
import { FC } from 'react';
import cx from 'classnames';
import { Conditional, TextHighlight } from '../../../common';
import styles from './HeaderSearchBarSuggestion.module.scss';
import { HeaderSearchBarSuggestionProps } from './types';
import { normalizeCommerceLink } from '../../../common/utils';
import { HEADLESS_CATEGORY_PAGE_BASE_PATH } from '../../../common/constants';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { CatIconDocumentParts } from '@blocks-react/components/Icons/DocumentParts';

export const HeaderSearchBarSuggestion: FC<HeaderSearchBarSuggestionProps> = ({
  items,
  label,
  highlightText = '',
  onItemClick,
  imgComp: Image = 'img',
  isHeadlessCategoryEnabled,
  seoURL = '',
  isFederatedSearchEnabled,
  listItemClassName,
  displayArrow = false,
  labelProps = { isStatic: true },
  displayPartsDiagramIcon = false
}) => (
  <Conditional test={items.length > 0}>
    <CatListItem {...labelProps}>
      <p
        className={cx(
          styles['header__search-bar-suggestion-label'],
          {
            [styles['header__search-bar-suggestion-label--federated-search']]:
              isFederatedSearchEnabled,
            [styles['header__search-bar-suggestion-label--display-arrow']]:
              displayArrow
          },
          'text-capitalize my-auto'
        )}
      >
        {label}
        {displayArrow ? (
          <CatIconChevronRight data-testid="chevron-right-icon" />
        ) : null}
      </p>
    </CatListItem>
    {items.map(({ displayName, name, value, imageURL, seoUrlKeyword = '' }) => {
      const itemName = name ?? displayName;

      const pccCategoryURL = normalizeCommerceLink(
        `${seoURL}/${seoUrlKeyword}`
      );
      const headlessCategoryURL = `${seoURL}/${HEADLESS_CATEGORY_PAGE_BASE_PATH}/${seoUrlKeyword}`;

      const categoryURL = isHeadlessCategoryEnabled
        ? headlessCategoryURL
        : pccCategoryURL;

      const suggestionURL = seoUrlKeyword ? categoryURL : value;
      const shouldDisplayPartsDiagramIcon =
        !imageURL && displayPartsDiagramIcon;

      return (
        <CatListItem
          href={suggestionURL}
          data-testid={itemName}
          key={`${itemName}${value}`}
          value={itemName}
          onClick={() => onItemClick(itemName)}
          className={isFederatedSearchEnabled ? listItemClassName : ''}
        >
          <Conditional test={!!imageURL}>
            <Image
              slot="before"
              loading="lazy"
              height={48}
              width={48}
              className={styles['header__search-bar-suggestion-image']}
              alt={itemName}
              src={`${imageURL}&wid=48&hei=48&fmt=png-alpha`}
            />
          </Conditional>
          <Conditional test={shouldDisplayPartsDiagramIcon}>
            <CatIconDocumentParts
              data-testid="document-parts"
              slot="before"
              size="xl"
              className={
                styles['header__search-bar-suggestion-parts-diagram-icon']
              }
            />
          </Conditional>
          <TextHighlight text={itemName} textToHighlight={highlightText} />
        </CatListItem>
      );
    })}
  </Conditional>
);
